import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../StyledTypography';
import StyledTabs from '../StyledTabs/StyledTabs';
import styles from './Profile.module.css';

const ProfileCommon = ({ tabs, activeTab, onTabChange, sections }) => {
  const [t] = useTranslation();
  return (
    <div className="container mt-4 col-md-10">
      <StyledTabs
        value={activeTab}
        onChange={onTabChange}
        className={styles.tabs}
        tabs={tabs.map((label) => ({ key: label, label: t(label) }))}
      />

      {sections.map((section, idx) => (
        <div key={idx} className={styles.card}>
          <Typography variant="subtitle" className={styles.header}>
            {section.title}
          </Typography>
          {section.content}
        </div>
      ))}
    </div>
  );
};

export default ProfileCommon;
